<template>
  <div class="purchase-package-body">
    <div class="bg-white rounded p-4">
      <b-form @submit.prevent="submitModeOfPayment">
        <b-form-group
          label-class="h2-label-class mb-3 d-flex">
          <template slot="label">
            <span class="flex-shrink-0 mr-3">{{ label }}</span>
            <b-form-invalid-feedback
              :force-show="!validateState('payment_types')">
              {{ formErrors.payment_types }}
            </b-form-invalid-feedback>
          </template>
          <b-form-checkbox-group
            v-model="form.payment_types"
            stacked>
            <b-form-checkbox
              v-for="(type, typeIndex) in paymentMethods"
              :key="`payment_type_${typeIndex}`"
              :value="type.value">
              <span class="label-text position-relative">{{ type.label }}</span>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        <b-form-group>
          <b-button
            variant="ghost"
            class="btn-cancel mr-3 px-4 py-2"
            @click="$router.go(-1)">
            Cancel
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            class="save-button px-4 py-2">
            Save
          </b-button>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import required from "vuelidate/lib/validators/required";

export default {
  data() {
    return {
      label: "Mode of Payment",
      form: {
        payment_types: []
      },
      paymentMethods: [
        { value: "CC_XENDIT", label: "Credit Card" },
        { value: "GCASH_XENDIT", label: "GCash" },
        { value: "GRAB_PAY_XENDIT", label: "GrabPay" },
        { value: "PAYMAYA_XENDIT", label: "Maya" },
        { value: "SHOPEEPAY_XENDIT", label: "ShopeePay" }
      ]
    }
  },
  computed: {
    ...mapState("purchasePackages", {
      paymentTypes: state => state.payment_types,
      purchasePackagesErrors: state => state.errors
    }),
    formErrors() {
      let errors = {
        payment_types: this.purchasePackagesErrors && this.purchasePackagesErrors.payment_types
          ? this.purchasePackagesErrors.payment_types
          : null
      };

      if (this.$v.form.payment_types.$dirty && !this.$v.form.payment_types.required)
        errors.payment_types = "This field is required.";

      return errors;
    }
  },
  created() {
    this.initPage();
  },
  validations: {
    form: {
      payment_types: {
        required
      }
    }
  },
  methods: {
    async initPage() {
      await this.$store.dispatch("purchasePackages/getPrivilegeCardDetails");
      if (!this.purchasePackagesErrors)
        this.form.payment_types = this.paymentTypes;
    },
    validateState(name) {
      if (this.formErrors[name]) return false;

      const { $dirty, $error } = this.$v.form[name];

      return $dirty ? !$error : null;
    },
    async submitModeOfPayment() {
      const available_mode_of_payments = this.paymentMethods.map(type => type.value);
      this.form.payment_types = this.form.payment_types
        .filter(
          type => available_mode_of_payments.includes(type)
        );

      this.$v.form.$touch();

      if (!this.$v.form.$invalid)
        await this.$store.dispatch("purchasePackages/savePrivilegeCardSettings", this.form);
    }
  }
}
</script>

<style lang="scss">
.h2-label-class {
  font-size: 16px;
  font-family: MainFontBold, sans-serif;
  color: #2a2a2a;
  .invalid-feedback {
    font-family: MainFontRegular, sans-serif;
  }
}
</style>

<style lang="scss" scoped>
.btn-cancel {
  border-radius: 22px !important;
}
.label-text {
  top: -2px;
}
</style>
